
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetosolapurtaxi() {



    const cardData =
    {
        keyword: ' Pune to Solapur Taxi',
        heading: 'Prince Cabs: Pune to Solapur Taxi',
        headingDescription: 'Prince Cabs offers reliable Pune to Solapur Taxi services, ideal for business travel, family trips, pilgrimages, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride to Solapur, home to the famous Siddheshwar Temple, textile markets, and cultural landmarks. With professional chauffeurs, on-time pickups, and flexible travel plans, we make your Pune to Solapur journey hassle-free. Enjoy affordability, safety, and convenience with Prince Cabs’ trusted taxi service from Pune to Solapur.',

        top: 'Top Places to Visit in Solapur with Prince Cabs',

"topPlaces": [
  {
    "title": "Siddheshwar Temple & Lake",
    "description": "The Siddheshwar Temple is Solapur’s most iconic spiritual site, dedicated to Lord Siddheshwar, an incarnation of Lord Shiva. Surrounded by a scenic lake, the temple is located in the heart of the city and attracts thousands of devotees every day. Its striking Hemadpanti architecture and peaceful atmosphere make it a major pilgrimage spot. During Makar Sankranti, a grand fair is held here, drawing lakhs of visitors. The temple complex offers a blend of faith, history, and natural beauty. It is considered the cultural and spiritual heart of Solapur."
  },
  {
    "title": "Great Indian Bustard Sanctuary (Nannaj)",
    "description": "Located near Solapur, the Great Indian Bustard Sanctuary in Nannaj is one of the last remaining habitats of the endangered Great Indian Bustard. Spread across vast grasslands, it also shelters blackbucks, wolves, and migratory birds. Wildlife enthusiasts and photographers flock here to catch glimpses of this rare bird. The sanctuary plays a vital role in conservation efforts. Winters are the best time to visit, as the landscape is lush and full of bird activity. It is a must-visit for eco-tourism lovers."
  },
  {
    "title": "Bhuikot Fort",
    "description": "Bhuikot Fort, built during the Bahmani Sultanate in the 14th century, is a historic monument in Solapur. The fort features impressive stone walls, bastions, and gateways. Inside, it houses the famous Siddheshwar Temple, mosques, and lush gardens. The fort is a symbol of Solapur’s rich history of Hindu-Muslim cultural harmony. Tourists enjoy exploring its architectural marvels and learning about its strategic importance. Today, it serves as a heritage site as well as a social gathering place. It remains a proud reminder of Solapur’s past."
  },
  {
    "title": "Akkalkot Swami Samarth Maharaj Temple",
    "description": "Located 38 km from Solapur, the Akkalkot Temple is dedicated to Shri Swami Samarth, a revered saint and incarnation of Lord Dattatreya. The temple complex houses Swami Samarth’s samadhi and attracts devotees from across India. Daily rituals and bhajans create a deeply spiritual atmosphere. Pilgrims believe that visiting Akkalkot brings peace, prosperity, and blessings. The temple is surrounded by simple yet serene surroundings. It is a major religious attraction and part of the Dattatreya pilgrimage circuit."
  },
  {
    "title": "Pandharpur Vitthal Rukmini Temple",
    "description": "Pandharpur, located about 75 km from Solapur, is one of Maharashtra’s most important pilgrimage centers. The Vitthal Rukmini Temple, dedicated to Lord Vitthal (a form of Lord Krishna) and Goddess Rukmini, attracts millions of devotees annually. The temple is the spiritual home of the Warkari sect, who walk hundreds of kilometers in processions (Waris) during Ashadhi and Kartiki Ekadashi. The temple’s black stone idol of Lord Vitthal is iconic. Pilgrims consider Pandharpur as ‘Dakshin Kashi.’ It is the soul of spiritual Maharashtra."
  },
  {
    "title": "Tuljapur Bhavani Temple",
    "description": "Situated about 45 km from Solapur, the Tuljapur Temple is dedicated to Goddess Bhavani, considered one of the Shakti Peethas. The temple is highly revered, as Goddess Bhavani was the kuldevi (family deity) of Chhatrapati Shivaji Maharaj. The idol, carved in stone, is adorned with jewels and worshipped with great devotion. The temple complex sees huge crowds during Navratri. Its hilltop location and spiritual energy create a divine atmosphere. Tuljapur is a must-visit for devotees and history lovers."
  },
  {
    "title": "Solapur Textile Market",
    "description": "Solapur is known as the ‘Textile City’ of Maharashtra, famous for its cotton bedsheets, towels, and handloom products. The textile markets here bustle with shops selling locally-made fabrics and home decor items. Solapur chaddars (bedsheets) are particularly popular across India. Tourists love buying authentic cotton products as souvenirs. The markets also reflect the city’s industrial heritage and economic backbone. It is a shopper’s paradise for those looking for quality and traditional craftsmanship."
  },
  {
    "title": "Kambar Talav (Lake)",
    "description": "Kambar Talav is a scenic lake located in Solapur, providing a peaceful retreat for locals and tourists. The lake is surrounded by gardens and walking tracks, making it a popular spot for evening strolls and family picnics. Migratory birds visit during winter, adding charm for birdwatchers. The calm waters and greenery make it ideal for relaxation. The site is well-maintained and attracts nature lovers. It is a refreshing break from the busy city life of Solapur."
  },
  {
    "title": "Hippie Island – Mangalwedha",
    "description": "Mangalwedha, near Solapur, is known as the land of saints like Sant Damaji and Sant Chokhamela. It is considered a spiritual hub in Maharashtra, attracting devotees of the Bhakti movement. Traditional bhajans, abhangs, and cultural gatherings keep the legacy alive. The town also has temples and mathas dedicated to saints. Visitors experience the rich devotional culture of rural Maharashtra here. Mangalwedha connects spirituality with community traditions. It is a soul-enriching stop on the Solapur circuit."
  },
  {
    "title": "Karmala Fort & Temples",
    "description": "Karmala, located in Solapur district, is famous for its historic fort and temples. The fort has impressive stone walls and ancient gateways, showcasing Maratha-era architecture. The town also houses the famous Siddheshwar Temple and other shrines. Pilgrims and tourists visit to explore the fort and soak in its cultural heritage. Festivals bring the town alive with traditional rituals and fairs. Karmala is a blend of history, devotion, and rustic charm. It adds depth to Solapur’s travel experiences."
  }
],


"services": [
    {
        "name": "Pune to Solapur Cab",
        "description": "Travel comfortably from Pune to Solapur with our reliable cab service. Whether you're visiting for business, leisure, or family events, our well-maintained vehicles and professional drivers ensure a smooth, safe, and timely journey. Enjoy personalized pickup and drop-off options tailored to your schedule."
    },
    {
        "name": "Innova Taxi from Pune to Solapur",
        "description": "Choose our spacious and premium Innova taxis for the Pune to Solapur route. Perfect for families and groups, the Innova offers ample legroom, luggage space, and air conditioning to make your long-distance journey relaxing and enjoyable. Experience a blend of comfort and convenience with our trusted drivers."
    },
    {
        "name": "Cab from Pune to Solapur",
        "description": "Book a dependable cab from Pune to Solapur with us, featuring a range of vehicle options to suit your travel needs and budget. Whether you prefer a sedan, SUV, or luxury cab, we prioritize safety, cleanliness, and punctuality to provide you with the best travel experience."
    },
    {
        "name": "Pune to Solapur Cab Fare",
        "description": "Get transparent and competitive cab fares for your journey from Pune to Solapur. Our pricing includes fuel, tolls, and driver allowance with no hidden charges. Choose flexible payment options and enjoy value-for-money travel without compromising on comfort or safety."
    },
    {
        "name": "Pune to Solapur Cab Price",
        "description": "Explore affordable cab prices for trips between Pune and Solapur. We offer fixed and negotiable rates based on your preferred vehicle type and trip duration, including one-way and round-trip services. Benefit from our cost-effective packages designed to fit your travel budget."
    },
    {
        "name": "Pune to Solapur Taxi",
        "description": "Our taxi service from Pune to Solapur offers a reliable and hassle-free option for both individual and group travelers. Experience professional driving, easy booking, and timely pickups, with vehicles equipped for long-distance comfort and safety."
    },
    {
        "name": "Pune to Solapur Cab Service",
        "description": "Avail of our comprehensive cab service from Pune to Solapur that covers everything from airport pickups to point-to-point travel. We maintain a fleet of clean, well-serviced vehicles driven by experienced chauffeurs dedicated to making your journey smooth and pleasant."
    },
    {
        "name": "Pune to Solapur Round Trip Cab",
        "description": "Plan your round-trip journey between Pune and Solapur with our dedicated cab service. Stay flexible with multiple stops and sightseeing options, while enjoying a vehicle reserved exclusively for your travel dates. Ideal for business trips, family visits, and leisure tours."
    },
    {
        "name": "Pune to Solapur Dzire Taxi",
        "description": "Choose our Dzire taxi for an economical and comfortable ride from Pune to Solapur. This sedan is perfect for small families, couples, or solo travelers, offering smooth rides, air conditioning, and efficient fuel usage at affordable rates."
    },
    {
        "name": "Pune to Solapur Innova Cab",
        "description": "Travel in style and comfort with our Innova cab service from Pune to Solapur. Designed for larger groups and families, this spacious vehicle offers premium seating, climate control, and ample luggage space, ensuring a pleasant long-distance travel experience."
    },
    {
        "name": "Pune to Solapur Affordable Taxi",
        "description": "Looking for budget-friendly taxi options from Pune to Solapur? Our affordable taxi service delivers reliable vehicles, transparent pricing, and professional drivers to ensure you get the best travel experience without overspending."
    }
],
"tableData": [
    ["Pune to Solapur Cab", "Innova Taxi from Pune to Solapur"],
    ["Cab from Pune to Solapur", "Pune to Solapur Cab Fare"],
    ["Pune to Solapur Cab Price", "Pune to Solapur Taxi"],
    ["Pune to Solapur Cab Service", "Pune to Solapur Round Trip Cab"],
    ["Pune to Solapur Dzire Taxi", "Pune to Solapur Innova Cab"],
    ["Pune to Solapur Affordable Taxi", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Dependable Pune to Solapur Taxi Service",
        "WhyChoosedescription": "Prince Cabs provides reliable and comfortable taxi services from Pune to Solapur, catering to travelers visiting for business, family functions, educational purposes, or temple visits. We ensure a smooth, hassle-free journey over the approximately 260 km route, making your long-distance travel safe and enjoyable."
    },
    {
        "WhyChooseheading": "Comfortable, Spacious, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes air-conditioned sedans, SUVs, and tempo travellers that are regularly serviced and equipped with clean, ergonomic seating and ample luggage space. Whether you’re traveling alone or with family or friends, our vehicles guarantee a relaxing and stress-free ride to Solapur."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Extensive Route Knowledge",
        "WhyChoosedescription": "Our professional drivers have deep knowledge of the Pune to Solapur route and alternate highways to avoid traffic delays. They prioritize your safety, offer courteous service, and can recommend ideal stops for meals or breaks, ensuring your journey is smooth and timely."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Needs",
        "WhyChoosedescription": "We offer customizable booking options including one-way trips, round trips, and multi-day rentals to accommodate your travel plans. Whether you need early morning pickups or late-night returns, Prince Cabs is ready to adjust to your schedule with easy booking through call, online, or WhatsApp."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Measures",
        "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized before and after each trip to ensure passenger health and safety. Our fleet undergoes regular maintenance and is equipped with essential safety features such as seat belts, GPS tracking, and first-aid kits for peace of mind throughout your journey."
    },
    {
        "WhyChooseheading": "Transparent Pricing with Multiple Payment Methods",
        "WhyChoosedescription": "Prince Cabs offers upfront pricing with no hidden charges for Pune to Solapur taxi services. We accept secure payments through UPI, credit/debit cards, net banking, and cash, providing convenience and trust in every transaction."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist you with bookings, cancellations, route inquiries, and any travel-related concerns. We ensure your Pune to Solapur taxi experience is smooth, coordinated, and stress-free from start to finish."
    }
]




















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide Pune to Solapur taxi services?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable taxi services from Pune to Solapur, suitable for business, personal, and pilgrimage travel.',
    },
    {
        question: 'What types of taxis are available for the Pune to Solapur route?',
        answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers to cater to solo travelers, families, and groups of all sizes.',
    },
    {
        question: 'Is the Pune to Solapur journey comfortable with Prince Cabs?',
        answer: 'Absolutely! Our vehicles are air-conditioned, spacious, and regularly serviced. Experienced drivers ensure a smooth and safe ride.',
    },
    {
        question: 'Can I book a one-way or round-trip taxi from Pune to Solapur?',
        answer: 'Yes, we offer both one-way and round-trip taxi options. You can also request flexible pickup and drop-off points as needed.',
    },
    {
        question: 'What are the taxi charges from Pune to Solapur?',
        answer: 'Taxi fares depend on vehicle type, travel duration, and any additional requirements. Contact Prince Cabs for a transparent and competitive quote.',
    },
    {
        question: 'How can I book a Pune to Solapur taxi with Prince Cabs?',
        answer: 'You can book easily via our website or by calling our customer support. Share your travel details and we’ll assist with the best cab option.',
    },
    {
        question: 'Are your taxis clean and safe for long-distance travel?',
        answer: 'Yes, all our taxis are sanitized, clean, and maintained regularly. We prioritize customer safety and comfort for every intercity trip.',
    },
];

const testimonials = [
    {
        name: "Mr. Ashok Shinde",
        position: "Corporate Client",
        text: "I frequently travel from Pune to Solapur and Prince Cabs is my go-to. Their cars are clean and their drivers are always on time.",
        image: "/img/testimonial/testimonial-thumb-solapur-1.png",
    },
    {
        name: "Mrs. Varsha Pawar",
        position: "Pilgrim Traveler",
        text: "Our family trip to Solapur for temple darshan was very smooth thanks to Prince Cabs. The taxi was comfortable and the driver was courteous.",
        image: "/img/testimonial/testimonial-thumb-solapur-2.png",
    },
];
































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Solapur Taxi",
  "image": "https://princecab.com/assets/images/pune-solapur-taxi.jpg",
  "description": "Book Pune to Solapur taxi service with Prince Cabs. Reliable and affordable options including Innova, Dzire, and family cabs. Ideal for round trips and one-way travel. 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.6",
    "ratingCount": "6300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4200",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/pune-to-solapur-taxi"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Solapur Taxi | Affordable & Reliable Cab Service | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers Pune to Solapur taxi service with Innova, Dzire, and family cabs. Affordable fares for round trips and one-way travel. Book your taxi online 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Solapur Cab, Innova Taxi from Pune to Solapur, Cab from Pune to Solapur, Pune to Solapur Cab Fare, Pune to Solapur Cab Price, Pune to Solapur Taxi, Pune to Solapur Cab Service, Pune to Solapur Round Trip Cab, Pune to Solapur Dzire Taxi, Pune to Solapur Innova Cab, Pune to Solapur Affordable Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosolapurtaxi;